"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarSeat = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CarSeat = function CarSeat(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.695 12.398l-2.984.331a1.742 1.742 0 01-1.84-1.15L3.94 6.174a.75.75 0 00-.707-.498 1.98 1.98 0 00-.476.06 26.514 26.514 0 01-.074-1.237h.242a.75.75 0 00.74-.626l.283-1.695a1.856 1.856 0 00-.63-1.73 1.856 1.856 0 00-1.805-.35A.75.75 0 001 .81v2.94c0 .391.301.709.683.743.02.646.06 1.252.116 1.815-.039.042-.084.076-.12.12a1.972 1.972 0 00-.376 1.687l1.72 7.307a.75.75 0 00.73.578H9.75a.753.753 0 00.494-.185l1.41-1.233c.415-.361.544-.942.323-1.445a1.252 1.252 0 00-1.282-.74zm4.265 2.61l-1.265-3.719A2.264 2.264 0 0011.29 9.78l-1.354.166-1.29-3.458a.75.75 0 00-.7-.488H6a.75.75 0 00-.707 1l1.5 4.25a.754.754 0 00.798.495l3.883-.476a.749.749 0 01.8.503l1.266 3.72a.75.75 0 101.42-.483zM4.5 3.25a1.75 1.75 0 113.5.001 1.75 1.75 0 01-3.5 0z",
    fill: "currentColor"
  }));
};

exports.CarSeat = CarSeat;
var _default = CarSeat;
exports.default = _default;